import React from "react";
import { Check } from "@phosphor-icons/react";
import { THEMES } from "@/lib/themes";
import { useTheme } from "@/context/ThemeContext";

const GROUPS = ["Apple style", "Coding classics", "Original"];
const CLASSIC = { slate: ["#f8fafc", "#f1f5f9", "#e2e8f0", "#cbd5e1", "#94a3b8", "#64748b", "#475569", "#334155", "#1e293b", "#0f172a", "#020617"], acc: [null, null, null, null, null, "#f97316"] };

function Preview({ th }) {
  const s = th.slate || CLASSIC.slate;
  const a = (th.acc || CLASSIC.acc)[5];
  const glass = th.glass ? "linear-gradient(135deg,#3fa9c9,#c9a27a 60%,#3c9f96)" : s[9];
  return (
    <div className="h-28 rounded-sm overflow-hidden flex border" style={{ background: glass, borderColor: s[7] }}>
      <div className="w-1/4 p-2 space-y-1.5" style={{ background: th.glass ? "rgba(255,255,255,.12)" : s[10], borderRight: `1px solid ${s[7]}` }}>
        <div className="h-2.5 w-2.5 rounded-sm" style={{ background: a }} />
        {[70, 50, 60, 45].map((w, i) => (
          <div key={i} className="h-1.5 rounded" style={{ width: `${w}%`, background: i === 0 ? s[2] : s[5], opacity: i === 0 ? 1 : 0.6 }} />
        ))}
      </div>
      <div className="flex-1 p-2.5 space-y-2">
        <div className="flex justify-between items-center">
          <div className="h-2 w-1/3 rounded" style={{ background: s[1] }} />
          <div className="h-3.5 w-10 rounded-sm" style={{ background: a }} />
        </div>
        <div className="grid grid-cols-2 gap-1.5">
          {[0, 1].map((i) => (
            <div key={i} className="h-12 rounded-sm p-1.5 space-y-1" style={{ background: th.glass ? "rgba(255,255,255,.14)" : s[8], border: `1px solid ${s[7]}` }}>
              <div className="h-1 w-1/2 rounded" style={{ background: s[5] }} />
              <div className="h-2 w-3/4 rounded" style={{ background: i ? a : s[1] }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function ThemeCard({ th, active, onPick }) {
  return (
    <button type="button" onClick={() => onPick(th.key)} data-testid={`theme-card-${th.key}`}
      className={`text-left surface p-3 transition-transform hover:-translate-y-0.5 ${active ? "ring-2 ring-orange-500" : ""}`}>
      <Preview th={th} />
      <div className="mt-3 flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="font-semibold text-slate-100 truncate">{th.name}</div>
          <div className="text-xs text-slate-400">{th.mode === "light" ? "Light" : "Dark"}{th.tag ? ` · ${th.tag}` : ""}</div>
        </div>
        {active && (
          <span className="inline-flex items-center gap-1 text-xs font-semibold text-orange-400" data-testid={`theme-active-${th.key}`}>
            <Check size={14} weight="bold" /> Active
          </span>
        )}
      </div>
    </button>
  );
}

export default function ThemePage() {
  const { themeKey, choose } = useTheme();
  return (
    <div className="space-y-8 max-w-6xl" data-testid="theme-page">
      <div>
        <h1 className="text-3xl font-heading font-bold text-slate-100">Theme</h1>
        <p className="text-sm text-slate-400 mt-1">Jo theme pasand ho us par tap karo — poori app turant badal jayegi.</p>
      </div>
      {GROUPS.map((g) => (
        <section key={g} className="space-y-3" data-testid={`theme-group-${g.replace(/\s+/g, "-").toLowerCase()}`}>
          <h2 className="text-sm font-semibold text-slate-300">{g}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {THEMES.filter((t) => t.group === g).map((th) => (
              <ThemeCard key={th.key} th={th} active={themeKey === th.key} onPick={choose} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
